<template lang="pug">
    v-container.pb-md-5.width-100-percent.brown.lighten-5#message-dashboard-container(style="margin-top: 0px !important;")
        v-row
            v-col(cols="8")
                v-card.overflow-y-auto(
                    height="600px"
                    elevation="4"
                    shaped
                )
                    v-toolbar(dense)
                        v-icon.mr-2 mdi-trophy
                        v-toolbar-title Account History

                    v-card-text
                        Historical(
                            :ownable-id="currentUser.activated_account_id"
                            :ownable-type="'account'"
                        )

            v-col(cols="4")
                Today(
                    :goals="goalsByRecurringTypeForToday"
                    :sheet-height="600"
                )
        v-row
            v-col(cols="12")
                Agents(

                )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import Agents from '@/components/dashboards/live/tabs/goals/agents.vue';
    import Historical from '@/components/dashboards/live/tabs/goals/historical.vue';
    import Today from '@/components/dashboards/live/tabs/goals/today.vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            validGoalsByRecurringTypeForToday() {
                return Object.keys(this.goalsByRecurringTypeForToday).length > 0;
            },
        },
        components: {
            Agents,
            Historical,
            Today,
        },
        props: {
            goalsByRecurringTypeForToday: Object,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
        },
    });
</script>

<style lang="scss" scoped>
</style>
